import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  pulse?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  pulse = true,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-xl ${pulse ? "animate-cta-pulse" : ""} ${className}`} data-id="element-28" data-mp="ck9cdgfx3e9o">
      <span data-id="element-29" data-mp="19bl45d1wqyh1">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="198yzbl6eix2i" />
    </a>;
}